module.exports = __webpack_public_path__ + "media/packs/images/partners/partner8-f155feb5f6de6357baecb53956e3de8f.jpg";